import saveWasteEntry from "./saveWasteEntry";

export default [...saveWasteEntry];
